import React from "react";
import BookSwimlane from "../bookviews/book-swimlane";
import { connect } from "react-redux";
import { selectors as booksSelectors } from "../../../../redux/books";
import { selectors as brandSelectors } from "../../../../redux/brand";
import { t } from "../../../core/translate";
import ExpiredBook from "../book/expired-book";

const ExpiredBooksLane = ({ expiredBooks, expLaneEnabled, onHeaderClick }) => {
  if (expLaneEnabled && expiredBooks.length) {
    const headerText = t("recent-expired.recently-expired", "Expired");
    return (
      <BookSwimlane
        BookObject={ExpiredBook}
        isbns={expiredBooks}
        headerLabel={headerText}
        count={expiredBooks.length}
        onHeaderClick={onHeaderClick}
      />
    );
  }
  return false;
};

const mapStateToProps = state => {
  return {
    expLaneEnabled: brandSelectors.getBrandValue(
      state,
      "ExpiredBooks.expiredBooksLane"
    ),
    expiredBooks: booksSelectors.getAllExpiredIsbns(state)
  };
};

export default connect(mapStateToProps, null)(ExpiredBooksLane);
